export type SuitabilityGrade = 'A' | 'B' | 'C' | 'D' | 'E'

export const SUITABILITY_GRADE_LABELS: Record<SuitabilityGrade, string> = {
  A: 'A – Highly usable',
  B: 'B – Usable',
  C: 'C – Moderate',
  D: 'D – Limited',
  E: 'E – Not suitable',
}

export interface LayerSuitabilityRecord {
  layer_id: string
  use_case_slug: string
  use_case_name: string
  suitability_grade: SuitabilityGrade
  suitability_statement_md?: string
}

export interface UpdateLayerSuitabilityPayload {
  suitability_grade: SuitabilityGrade
  suitability_statement_md?: string
}

export interface UpsertAllLayerSuitabilitiesPayload {
  suitabilities: {
    use_case_slug: string
    suitability_grade: SuitabilityGrade
    suitability_statement_md?: string
  }[]
}

export const SUITABILITY_GRADES: SuitabilityGrade[] = ['A', 'B', 'C', 'D', 'E']

export type SuitabilityCreateForm = {
  useCaseSlug: string
  grade: SuitabilityGrade
  statementMd: string
}
